function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M506.442,413.537L401.146,308.242c-3.585-3.585-8.35-5.558-13.42-5.558c-3.507,0-6.857,0.964-9.783,2.733l-59.154-59.154 c-3.032-3.031-7.947-3.031-10.979,0c-3.031,3.031-3.031,7.947,0,10.978l58.748,58.748l-21.643,21.643L237.159,229.876 l21.643-21.643l14.419,14.417c3.03,3.032,7.946,3.031,10.978,0c3.031-3.032,3.031-7.947-0.001-10.978l-14.418-14.417 l37.521-37.521l2.969,2.969c3.687,3.688,8.591,5.719,13.808,5.719c5.216,0,10.119-2.031,13.808-5.719l13.83-13.83 c3.687-3.688,5.719-8.592,5.719-13.807c0-5.216-2.032-10.12-5.719-13.807L245.599,15.141c-3.687-3.688-8.591-5.72-13.808-5.72 c-5.216,0-10.119,2.031-13.806,5.719l-13.831,13.83c-3.688,3.688-5.72,8.591-5.72,13.808c0,5.215,2.032,10.119,5.719,13.807 l2.969,2.969L88.48,178.196l-2.969-2.969c-7.613-7.612-20.001-7.612-27.614,0.001l-13.83,13.83 c-3.687,3.688-5.719,8.592-5.719,13.807c0,5.216,2.032,10.12,5.719,13.807l106.115,106.116c3.688,3.688,8.592,5.719,13.808,5.719 s10.119-2.031,13.807-5.719l13.831-13.83c0.001,0,0.001,0,0.001,0c7.611-7.613,7.612-20,0-27.614l-2.969-2.969l37.52-37.52 l108.163,108.163c-1.769,2.926-2.733,6.276-2.733,9.783c0,5.069,1.974,9.835,5.558,13.42l105.295,105.295 c3.585,3.585,8.35,5.558,13.421,5.558c5.069,0,9.834-1.974,13.42-5.558l37.138-37.138c3.584-3.584,5.558-8.35,5.558-13.42 S510.026,417.121,506.442,413.537z M215.132,39.949l13.832-13.831c0.755-0.755,1.76-1.171,2.827-1.171 c1.068,0,2.073,0.416,2.828,1.172l106.117,106.116c0.755,0.755,1.172,1.76,1.172,2.828s-0.416,2.073-1.173,2.829l-13.829,13.83 c-1.512,1.511-4.147,1.512-5.658,0.001L215.133,45.607c-0.756-0.756-1.173-1.76-1.173-2.829 C213.96,41.709,214.377,40.706,215.132,39.949z M180.65,297.979l-13.832,13.83c-1.51,1.511-4.146,1.511-5.657,0L55.045,205.693 c-0.755-0.755-1.172-1.76-1.172-2.828s0.416-2.073,1.173-2.829l13.829-13.83c0.78-0.78,1.804-1.17,2.829-1.17 c1.025,0,2.049,0.39,2.828,1.17l106.116,106.115C182.208,293.881,182.208,296.418,180.65,297.979z M220.69,224.386 c-0.001,0.001-0.001,0.001-0.002,0.002l-43.008,43.008l-78.222-78.221L218.101,70.534l78.221,78.221l-43.003,43.002 c-0.003,0.003-0.006,0.005-0.009,0.008L220.69,224.386z M495.462,429.398l-37.138,37.138c-0.879,0.88-1.906,1.011-2.44,1.011 c-0.535,0-1.562-0.131-2.441-1.011L348.148,361.24c-0.88-0.88-1.012-1.907-1.012-2.441s0.131-1.561,1.012-2.441l2.258-2.258 l34.879-34.88c0.879-0.88,1.906-1.011,2.441-1.011c0.534,0,1.561,0.131,2.44,1.011l105.296,105.295 c0.88,0.88,1.012,1.907,1.012,2.441S496.342,428.518,495.462,429.398z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M294.83,433.767h-11.894v-40.908c0-9.126-7.423-16.55-16.549-16.55H132.57c-4.288,0-7.763,3.476-7.763,7.763 s3.475,7.763,7.763,7.763h133.817c0.564,0,1.023,0.459,1.023,1.023v40.908H61.141v-40.908c0-0.565,0.459-1.023,1.023-1.023h21.63 c4.288,0,7.763-3.476,7.763-7.763s-3.475-7.763-7.763-7.763h-21.63c-9.126,0-16.549,7.424-16.549,16.55v40.908H33.721 C15.127,433.767,0,448.894,0,467.488v22.103c0,7.162,5.826,12.988,12.988,12.988h302.575c7.162,0,12.988-5.826,12.988-12.988 v-22.103C328.551,448.894,313.424,433.767,294.83,433.767z M313.026,487.053L313.026,487.053h-297.5v-19.565 c0-10.032,8.162-18.195,18.195-18.195h261.11c10.032,0,18.195,8.162,18.195,18.195V487.053z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var SvgLegal = function SvgLegal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLegal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/legal.3b04ca41.svg";
export { ForwardRef as ReactComponent };